import { FC } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { ImagePlaceholder } from 'partner360/components/imagePlaceholder/ImagePlaceholder'

import { TRANSLATION_KEYS } from '../../../../translations'

import styles from './DndCustomView.module.scss'

interface IDndCustomViewProps {
  openFileList: () => void
}

export const DndCustomView: FC<IDndCustomViewProps> = ({ openFileList }) => {
  return (
    <div className={styles.root}>
      <div className={styles.imageContainer}>
        <ImagePlaceholder />
      </div>
      <div className={styles.content}>
        <Translation htmlAvailable text={TRANSLATION_KEYS.qbrAttachments.dnd.dragAndDrop} />
        <Translation htmlAvailable text={TRANSLATION_KEYS.qbrAttachments.dnd.ctrlV} />
        <Translation htmlAvailable text={TRANSLATION_KEYS.qbrAttachments.dnd.or} />
        <div className={styles.browseFilesButton} onClick={openFileList}>
          <Translation htmlAvailable text={TRANSLATION_KEYS.qbrAttachments.dnd.browseFiles} />
        </div>
      </div>
    </div>
  )
}
